import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

type DivProps = HTMLAttributes<HTMLDivElement>;

export const Card = forwardRef<HTMLDivElement, DivProps>(function Card(
  { className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-aurum-lg border border-aurum-500/20 bg-onyx-700/80 backdrop-blur-sm',
        'shadow-aurum-deep',
        className,
      )}
      {...rest}
    />
  );
});

export const CardHeader = forwardRef<HTMLDivElement, DivProps>(function CardHeader(
  { className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn('p-6 pb-3', className)} {...rest} />;
});

export const CardTitle = forwardRef<HTMLDivElement, DivProps>(function CardTitle(
  { className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('font-display text-2xl text-aurum-200', className)}
      {...rest}
    />
  );
});

export const CardBody = forwardRef<HTMLDivElement, DivProps>(function CardBody(
  { className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn('px-6 py-3 text-cream-100', className)} {...rest} />;
});

export const CardFooter = forwardRef<HTMLDivElement, DivProps>(function CardFooter(
  { className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn('p-6 pt-3', className)} {...rest} />;
});
